
import ProductList from "./pages/ProductList";
import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Product from "./pages/Product";
import Register from "./pages/Register";

const App = () => {
    return <Home/>;
  };
  
  export default App;
